import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

const POLL_INTERVAL_MS = 60_000;

export function useAutoDraftCount(organizationId: string | undefined) {
  return useQuery<number>({
    queryKey: ["auto-draft-count", organizationId],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_auto_draft_count", {
        p_org_id: organizationId!,
      });

      if (error) throw error;
      return (data as number) ?? 0;
    },
    enabled: !!organizationId,
    refetchInterval: POLL_INTERVAL_MS,
  });
}
